<template>
    <div >
        <!-- <div class="bottons">
          <el-button style="float:right" type="primary" icon="el-icon-rank" size="mini" @click.stop="handleFullScreen()">全屏显示</el-button>
        </div> -->
        <el-dialog
            class="businessConsoleDialog"
            style="margin-bottom: -2%;"
            title="业务应用"
            :fullscreen=true
            :visible.sync="isShowConsole"
            @open="openedDialog"
            @close="hideDialog"
            >
            <BusinessAppMenu v-if="isShowAppMenu" :fullScreen="true" :menuFormIndex="menuFormIndex"/>
        </el-dialog>
    </div>
</template>

<script>
    // import { getFormConfig } from '@/data-model';
// import BusinessAppMenu from '@/pages/business/BusinessApplication/BusinessAppMenu';
    export default {
        components: {
            // BusinessAppMenu
        },
        data () {
            return {
                isShowConsole: false,
                isShowAppMenu: false
            };
        },
        props: {
            menuFormIndex: {
                type: String
            }
        },
    
        created () {
            // this.init_();
        },
        methods: {
            init_ () {
                this.handleFullScreen();
                setTimeout(() => {
                    this.openedDialog();
                }, 500);
            },
            hideDialog () {
                this.isShowConsole = false;
                this.isShowAppMenu = false;
                // this.$router.go(-1);
            },
            openedDialog () {
                this.isShowAppMenu = true;
            },
            handleFullScreen () {
                this.isShowConsole = true;
            }
        }
    };
</script>

<style lang="less">
   .bottons {
        display: flex;
        justify-content: space-between;
        margin: 10px 0 10px 10px;
    }
    .businessConsoleDialog{
      .el-dialog__header{
          margin-bottom: -2%;
          padding: 20px 20px 10px
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessApplication/BusinessConsole.vue